import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import Map from '../components/Map';
import * as actions from '../actions/map';

const tracksSelector = createSelector(
  state => state.map.selectedDay && state.map.selectedDay.tracks,
  tracks => tracks,
);

const mapStateToProps = state => ({
  selectedDay: state.map.selectedDay,
  days: state.map.days,
  tracks: tracksSelector(state),
  usersMap: state.map.usersMap,
  selectedUser: state.map.selectedUser,
  selectedGroup: state.map.selectedGroup,
  mapCenter: state.map.mapCenter,
});

const mapDispatchToProps = dispatch => ({
  onMapReady: () => dispatch(actions.selectDay(new Date())),
});

export default connect(mapStateToProps, mapDispatchToProps)(Map);



// WEBPACK FOOTER //
// ./src/containers/Map.js